/* BB_PROMO_MOBILE_CAROUSEL_V191 — progressive enhancement of native scroll-snap. */
(function () {
  'use strict';

  const initialized = new WeakSet();

  function setup(root) {
    if (initialized.has(root)) return;
    const track = root.querySelector('[data-bb-promo-track]');
    const cards = track ? Array.from(track.querySelectorAll(':scope > .bb-promo-inline')) : [];
    const prev = root.querySelector('[data-bb-promo-prev]');
    const next = root.querySelector('[data-bb-promo-next]');
    const current = root.querySelector('[data-bb-promo-current]');
    if (cards.length < 2 || !prev || !next || !current) return;
    initialized.add(root);

    let index = 0;
    let frame = 0;
    const mobile = window.matchMedia('(max-width: 767px)');

    function closestIndex() {
      const left = track.getBoundingClientRect().left;
      let closest = 0, min = Infinity;
      cards.forEach((card, i) => {
        const distance = Math.abs(card.getBoundingClientRect().left - left);
        if (distance < min) { min = distance; closest = i; }
      });
      return closest;
    }

    function sync() {
      index = mobile.matches ? closestIndex() : 0;
      current.textContent = String(index + 1);
      prev.disabled = index === 0;
      next.disabled = index === cards.length - 1;
    }

    function goTo(i) {
      if (!mobile.matches) return;
      const card = cards[Math.max(0, Math.min(cards.length - 1, i))];
      const left = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({
        left: left,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', () => goTo(index - 1));
    next.addEventListener('click', () => goTo(index + 1));
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => { frame = 0; sync(); });
    }, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(sync).observe(track);
    }
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    root.classList.add('bb-collection__promo--ready');
    sync();
  }

  function init() {
    document.querySelectorAll('[data-bb-promo-carousel]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('bb:facets:updated', init);
  document.addEventListener('shopify:section:load', init);
})();
